/* eslint-disable */
const Colors = {
  boralgreen: {
    50: `#e0f5ea`,
    100: `#b3e5ca`,
    200: `#80d4a7`,
    300: `#4dc384`,
    400: `#26b669`,
    500: `#00a94f`,
    600: `#00a248`,
    700: `#00983f`,
    800: `#008f36`,
    900: `#007e26`,
    A100: `#acffbe`,
    A200: `#79ff95`,
    A400: `#46ff6d`,
    A700: `#2cff59`,
    contrastDefaultColor: `light`,
  },

  boralyellow: {
    50: `#fffbe0`,
    100: `#fff5b3`,
    200: `#ffef80`,
    300: `#ffe84d`,
    400: `#ffe326`,
    500: `#ffde00`,
    600: `#ffda00`,
    700: `#ffd500`,
    800: `#ffd100`,
    900: `#ffc800`,
    A100: `#ffffff`,
    A200: `#fffcf2`,
    A400: `#fff0bf`,
    A700: `#ffe9a6`,
    contrastDefaultColor: `dark`,
  },

  atlantis: {
    50: `#f4f9e7`,
    100: `#e4f0c4`,
    200: `#d3e79d`,
    300: `#c1dd75`,
    400: `#b3d558`,
    500: `#a6ce3a`,
    600: `#9ec934`,
    700: `#95c22c`,
    800: `#8bbc25`,
    900: `#7bb018`,
    A100: `#f5ffe5`,
    A200: `#e2ffb2`,
    A400: `#ceff7f`,
    A700: `#c5ff65`,
    contrastDefaultColor: `dark`,
  },

  raven: {
    50: `#eef0f1`,
    100: `#d5d9dc`,
    200: `#b9c0c5`,
    300: `#9da6ad`,
    400: `#88939c`,
    500: `#73808a`,
    600: `#6b7882`,
    700: `#606d77`,
    800: `#56636d`,
    900: `#43505a`,
    A100: `#b8dffe`,
    A200: `#85c9fe`,
    A400: `#51b3ff`,
    A700: `#37a8ff`,
    contrastDefaultColor: `light`,
  },

  watercourse: {
    50: `#e0edea`,
    100: `#b3d1ca`,
    200: `#80b3a7`,
    300: `#4d9483`,
    400: `#267d69`,
    500: `#00664e`,
    600: `#005e47`,
    700: `#00533d`,
    800: `#004935`,
    900: `#003825`,
    A100: `#6effc2`,
    A200: `#3bffac`,
    A400: `#08ff96`,
    A700: `#00ee89`,
    contrastDefaultColor: `light`,
  },

  gimblet: {
    50: `#f7f6ed`,
    100: `#ebe8d1`,
    200: `#ded9b3`,
    300: `#d0ca94`,
    400: `#c6be7d`,
    500: `#bcb366`,
    600: `#b6ac5e`,
    700: `#ada353`,
    800: `#a59a49`,
    900: `#978b38`,
    A100: `#fffbe4`,
    A200: `#fff5b1`,
    A400: `#ffee7e`,
    A700: `#ffea64`,
    contrastDefaultColor: `dark`,
  },

  montecarlo: {
    50: `#f0fbfa`,
    100: `#daf6f4`,
    200: `#c2f0ec`,
    300: `#aae9e4`,
    400: `#97e5df`,
    500: `#85e0d9`,
    600: `#7ddcd5`,
    700: `#72d8cf`,
    800: `#68d3ca`,
    900: `#55cbc0`,
    A100: `#ffffff`,
    A200: `#fbffff`,
    A400: `#c8fffa`,
    A700: `#aefff7`,
    contrastDefaultColor: `dark`,
  },

  zambezi: {
    50: `#edebec`,
    100: `#d3cccf`,
    200: `#b6abb0`,
    300: `#988990`,
    400: `#826f78`,
    500: `#6c5660`,
    600: `#644f58`,
    700: `#59454e`,
    800: `#4f3c44`,
    900: `#3d2b33`,
    A100: `#ff8bbe`,
    A200: `#ff58a1`,
    A400: `#ff2585`,
    A700: `#ff0c76`,
    contrastDefaultColor: `light`,
  },

  california: {
    50: `#fef4e4`,
    100: `#fee3bb`,
    200: `#fdd18d`,
    300: `#fcbe5f`,
    400: `#fbb03d`,
    500: `#faa21b`,
    600: `#f99a18`,
    700: `#f99014`,
    800: `#f88610`,
    900: `#f67508`,
    A100: `#ffffff`,
    A200: `#fff3eb`,
    A400: `#ffd5b8`,
    A700: `#ffc69f`,
    contrastDefaultColor: `dark`,
  },

  pear: {
    50: `#fcfce7`,
    100: `#f7f8c3`,
    200: `#f1f49b`,
    300: `#ebef72`,
    400: `#e7eb54`,
    500: `#e3e836`,
    600: `#e0e530`,
    700: `#dce229`,
    800: `#d8de22`,
    900: `#d0d816`,
    A100: `#ffffff`,
    A200: `#fdffd6`,
    A400: `#fbffa3`,
    A700: `#faff8a`,
    contrastDefaultColor: `dark`,
  },
};

export default Colors;
